export default __webpack_public_path__ + "static/Card21-5626963a6500af71f4599db9345ce474.png";